import { render, staticRenderFns } from "./route-info-v2-add-city.vue?vue&type=template&id=09922dab&scoped=true&"
import script from "./route-info-v2-add-city.vue?vue&type=script&lang=ts&"
export * from "./route-info-v2-add-city.vue?vue&type=script&lang=ts&"
import style0 from "./route-info-v2-add-city.vue?vue&type=style&index=0&id=09922dab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09922dab",
  null
  
)

export default component.exports